import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppHeader from 'anchor-ui/app-header';
import logo from '../store/assets/logo.svg';

import { auth } from '../firebase';
import * as routes from '../constants/routes';

import Button from 'anchor-ui/button';
import TextField from 'material-ui/TextField';

import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = {
    HeaderLogo: {
      'height': '50px',
      'marginTop': '-5px',
      'marginLeft': '5px',
    },
    AppHeader: {
      'backgroundColor': '#EFF2EF',
    },
    TextStyle : {
        color: '#251447',
        paddingLeft: '5px',
        paddingTop: '7px',
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    },
    Button:{
        margin: '30px',
        marginLeft: '165px',
        backgroundColor: '#251447',
        opacity: 0.8,
    },
    TextField: {
        marginTop: '5px',
        width: '90%',
        marginLeft: '20px'
    },
    login: {
        width: '400px',
        margin: '0 auto',
        marginTop: '15%',
        backgroundColor: '#EFF2EF'
    },
    Progress: {
      marginTop: '45vh',
      marginLeft: '48vw'
    }
}


const SignInPage = ({ history: history, ...rest }) => {
  return (
    <div>
      <SignInForm history={history} {...rest}/>
    </div>
  )
}

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history, setLoginStatus, emails, uids
    } = this.props;
    if(emails.indexOf(email) > -1) {
      auth.doSignInWithEmailAndPassword(email, password)
      .then((authUser) => {
        if(uids.indexOf(authUser.user.uid) > -1) {
          this.setState({ ...INITIAL_STATE });
          localStorage.setItem('astrologerLoggedIn', true)
          setLoginStatus(true);
          history.replace(routes.ACCOUNT);
        } else {
          auth.doSignOut();
        }
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });
    } else {
      this.setState(byPropKey('error', {message: "Invalid login attempt"}))
    }

    event.preventDefault();
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const {
      emails
    } = this.props;

    const isInvalid =
      password === '' ||
      email === '';

    return (
        emails.length? <div className="login" style={styles.login}>
            <Paper center-justified="true" flex="true">
            <MuiThemeProvider>
            <div>
                <AppHeader style={styles.AppHeader}
                text="Horace Admin"
                icon={<img src={logo} alt="Horace Chat" style={styles.HeaderLogo}/>}
                textStyle={styles.TextStyle}
                />

            <form onSubmit={this.onSubmit}>
              <TextField
                floatingLabelText="Username"
                onChange={event => this.setState(byPropKey('email', event.target.value))}
                style={styles.TextField}
              />
              <TextField
                type="password"
                floatingLabelText="Password"
                onChange={event => this.setState(byPropKey('password', event.target.value))}
                style={styles.TextField}
              />
              <Button style={styles.Button} disabled={isInvalid}>LOGIN</Button>

        { error && <p>{error.message}</p> }
      </form>
      </div>
            </MuiThemeProvider>
            </Paper>
        </div>: <CircularProgress style={styles.Progress}/>
    );
  }
}

export default withRouter(SignInPage);

export {
  SignInForm,
};


// WEBPACK FOOTER //
// ./src/Components/SignIn.js